<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/ex/list">
            展商列表
          </BreadcrumbItem>
          <BreadcrumbItem>
            <span v-if="company && company.name">{{company.name}}</span>
            <span v-else>展商</span>
          </BreadcrumbItem>
          <BreadcrumbItem :to="`/host/index/ex/act?id=${editId}`">活动</BreadcrumbItem>
          <BreadcrumbItem>编辑活动</BreadcrumbItem>
        </Breadcrumb> 
        <div class="header-tool-title">编辑活动</div>
      </div>
      <div class="f-tar" style="padding-top: 37px;">
        <Button @click="$router.push(`/host/index/ex/act?id=${editId}`)">返回</Button>
      </div>
    </div>
    <div class="activity-add-content">
      <Form ref="formValidate" :model="formInline" :rules="ruleInline" :label-width="100">
        <FormItem label="活动名称：" prop="name">
          <Input style="width:400px;" v-model="formInline.name" placeholder="请输入活动名称" />
        </FormItem>
        <FormItem label="活动海报：" prop="actImg">
          <div class="my-upload">
            <div
              class="my-upload-list"
              v-for="(item, index) in uploadList"
              :key="'upload' + index"
            >
              <template v-if="item.status === 'finished'">
                <img :src="item.url" style="width: 100px;height: 100px;" />
                <div class="my-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                  <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                </Spin>
              </template>
            </div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :default-file-list="defaultList"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :headers="formHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              multiple
              type="drag"
              :action="uploadUrl"
              style="display: inline-block;"
              v-show="uploadList && uploadList.length < 15"
            >
              <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                <div style="font-size:25px">
                  +
                  <p style="font-size:14px">上传图片</p>
                </div>
              </div>
            </Upload>
            <iModal title="图片查看" cancel-text v-model="visible">
              <div style="text-align: center;">
                <img :src="imgName" v-if="visible" style="max-width: 100%" />
              </div>
            </iModal>
          </div>
          <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下jpg或png的图片，大小为：900*600px，最多上传15张)</p>
        </FormItem>
        <FormItem label="活动视频：">
          <div
            class="my-upload-list"
            v-for="(item, index) in uploadListVideo"
            :key="'uploadVideo' + index"
            style="width: 150px;height:100px;position: relative;"
          >
            <template v-if="item.status === 'finished'">
              <img :src="coverImg" style="width: 150px;height:100px;" />
              <div class="my-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleViewVideo(item)"></Icon>
                <Icon
                  type="ios-trash-outline"
                  @click.native.stop.prevent="handleRemoveByArrVideo(item)"
                ></Icon>
              </div>
            </template>
          </div>
          <Upload
            ref="uploadVideo"
            :show-upload-list="false"
            :on-success="handleSuccessVideo"
            :format="['mp4']"
            :max-size="51200"
            :headers="formHeaders"
            :on-format-error="handleFormatErrorVideo"
            :on-error="handleUploadErrorVideo"
            :on-exceeded-size="handleMaxSizeVideo"
            :before-upload="handleBeforeUploadVideo"
            :on-progress="handleUploadingVideo"
            :action="uploadVideoUrl"
            type="drag"
            style="display: inline-block;width:100px;height:100px;margin-bottom:10px;"
            v-show="uploadListVideo && uploadListVideo.length < 1"
          >
            <div style="width:100px;height:100px;padding-top: 15px;">
              <div style="font-size:20px">
                +
                <p style="font-size:14px;font-weight:normal;color:#515a6e;">上传视频</p>
              </div>
            </div>
          </Upload>
          <div class="uploading" v-if="uploading">
            <Spin>
              <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
            </Spin>
          </div>
          <p class="upload-p" style="font-size:12px;font-weight:normal;color:#515a6e;">(视频要求:视频大小不超过50M，建议视频时长9-30秒，视频宽高比16:9)</p>
        </FormItem>
        <!-- <FormItem label="活动名额：">
          <InputNumber
            v-model="formInline.num"
            :min="0"
            style="width:100px;margin-right:10px;"
          ></InputNumber>人
          <span style="font-size:12px;margin-left:10px;">(0表示不限量)</span>
        </FormItem> -->
        <FormItem label="时间：" prop="date">
          <DatePicker
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择活动时间"
            style="width: 400px;"
            @on-change="time1"
            v-model="applyDate"
          ></DatePicker>
        </FormItem>
        <FormItem label="活动日程：" prop="Timetable">
          <Input
            v-model="formInline.Timetable"
            type="textarea"
            :rows="4"
            placeholder="请输入活动日程"
            style="width: 400px"
          ></Input>
        </FormItem>
        <FormItem label="活动地点：">
          <Input style="width:400px;" v-model="formInline.address" placeholder="请输入活动地点" />
        </FormItem>
        <!-- <FormItem>
          <Checkbox size="large" v-model="formInline.apply" @on-change="changeApply()">
            <span style="display: inline-block;width: 10px;"></span>开启报名
          </Checkbox>
        </FormItem>
        <FormItem label="报名时间：" v-show="formInline.apply">
          <DatePicker
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择报名时间"
            style="width: 400px;"
            @on-change="time2"
            v-model="regDate"
          ></DatePicker>
        </FormItem>
        <FormItem v-show="formInline.apply">
          <Checkbox size="large" v-model="formInline.isCharge" @on-change="changeIsCharge()">
            <span style="display: inline-block;width: 10px;"></span>收费
          </Checkbox>
        </FormItem>
        <FormItem label="价格:" v-show="formInline.apply && formInline.isCharge" style="display:inline-block">
          <InputNumber
            v-model="formInline.price"
            placeholder="0"
            :min="0"
            style="width:100px;margin-right:10px;"
          ></InputNumber>元
        </FormItem>
        <FormItem label="划线价格：" v-show="formInline.apply && formInline.isCharge" style="display:inline-block">
          <InputNumber
            v-model="formInline.linePrice"
            placeholder="0"
            :min="0"
            style="width:100px;margin-right:10px;"
          ></InputNumber>元
        </FormItem> -->
        <FormItem label="显示顺序：">
          <InputNumber v-model="formInline.showIndex" :min="0" style="width:100px;margin-right:10px;"></InputNumber>
          <p style="font-size:12px;">(数字越小在您的活动显示列表中显示越靠前)</p>
        </FormItem>
        <FormItem label="活动详情：" class="ivu-form-item-required">
          <div class="no-padding ">
            <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
          </div>
        </FormItem>
      </Form>
      <div style="padding:50px 0 0 50px;">
        <Button style="width:150px;height:34px;" type="primary" :loading="loading" @click="handleSubmit('formValidate')">保存</Button>
      </div>
    </div>

    <!-- 查看已上传视频 -->
    <iModal cancel-text v-model="visibleVideo" class-name="vertical-center-modal act-video" :footer-hide="true" :z-index="1200">
      <div style="text-align: center;">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </iModal>
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { mapGetters, mapActions } from "vuex";
import { videoPlayer } from "vue-video-player";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";

export default {
  name: "exhibition-act-edit",
  data() {
    const that = this;
    const actImgReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传活动海报"));
      }
    };
    const proApply = (rule, value, callback) => {
      if (that.applyDate[1]) {
        callback();
      } else {
        callback(new Error("请选择活动时间"));
      }
    };
    return {
      company: null,
      editId: "",
      AgentId: "cd4e8cef-c6f7-4e72-9132-93161b9e8c43",
      uploadList: [],
      defaultList: [],
      imgName: "",
      visible: false,
      formInline: {
        name: "",
        // num: 0, // 活动名额
        Timetable: "", // 活动日程
        address: "",
        apply: false, // 是否开启报名
        isCharge: false, // 是否收费
        price: 0, // 价格
        linePrice: 0, // 划线价格
        showIndex: 0, // 显示顺序
      },
      ruleInline: {
        name: [
          { required: true, message: "活动名称不能为空", trigger: "blur" }
        ],
        // actImg: [{ required: true, validator: actImgReg, trigger: "blur" }],
        date: [{ required: true, validator: proApply, trigger: "blur" }]
      },
      loading: false,
      uploadListVideo: [],
      coverImg: "",
      uploading: false,
      videoData: null,
      visibleVideo: false,
      applyDate: [], // 活动开始-结束时间
      regDate: [], // 报名开始-结束时间
      Introduction: [], // 活动详情
      commonType: 2,
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders"
    }),
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "compId",
                  Value: `%${this.editId}%`
                }
              }
            ]
          }
        }
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    playerOptions() {
      let res = {};
      if (this.videoData) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.videoData.url
            }
          ],
          poster: this.coverImg,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    },
    actId() {
      return this.$route.query.id
    }
  },
  async created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getActById: "hostActModule/getActById",
      getCompanyByJoin: "hostSetModule/getCompanyByJoin",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      transformCustomData: "customComponentModule/transformCustomData",
      editActInfo: "hostActModule/editActInfo",
    }),
    async init() {
      let query = this.$route.query;
      if (query && query.compId) {
        this.editId = query.compId;
        let proData = await this.getCompanyByJoin(this.option);
        if (proData) {
          this.company = proData.items[0];
        }
      }
      let actDetail = await this.getActById(this.actId);
      console.log(actDetail);
      this.formInline.name = actDetail.name;
      if (JSON.parse(actDetail.banner)) {
        this.uploadList = this.transform(JSON.parse(actDetail.banner));
        this.defaultList = this.transform(JSON.parse(actDetail.banner));
      }
      if (JSON.parse(actDetail.video).Link) { 
        this.uploadListVideo = [
          {
            url: JSON.parse(actDetail.video).Link,
            src: JSON.parse(actDetail.video).Img,
            status: "finished"
          }
        ];
        this.coverImg = JSON.parse(actDetail.video).Img
      }
      // this.formInline.num = actDetail.regCountMax;
      this.formInline.address = actDetail.address;
      if (actDetail.startTime && actDetail.endTime) {
        this.applyDate = [actDetail.startTime, actDetail.endTime];
      }
      // this.formInline.apply = actDetail.isReg;
      // if (actDetail.regStart && actDetail.regEnd) {
      //   this.regDate = [actDetail.regStart, actDetail.regEnd];
      // }
      // this.formInline.isCharge = actDetail.isCharge;
      // this.formInline.price = actDetail.chargeAmount;
      // this.formInline.linePrice = actDetail.scribingAmount;
      this.formInline.showIndex = actDetail.showIndex;
      this.formInline.Timetable = actDetail.timetable;

      if (
        actDetail.introduction &&
        actDetail.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(actDetail.introduction)
        );
      }
    },
    transform(arr) {
      let arr2 = [];
      arr.map((itm,idx) => {
        arr2.push({
          status: "finished",
          percentage: 100,
          url: itm
        })
      })
      return arr2;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit(name) {
      let imgList = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      // 视频
      let video = {
        cover: 1,
        Time: 2000,
        Img: "",
        Link: ""
      };
      if (this.uploadListVideo.length > 0) {
        video.Link = this.uploadListVideo[0].url;
        video.Img = this.coverImg;
      }

      // 活动时间
      let startTime = this.applyDate[0];
      let endTime = this.applyDate[1];

      // // 是否开启报名及报名时间
      // let regStart = "";
      // let regEnd = "";
      // if (this.formInline.apply) {
      //   if (this.regDate.length <= 0) {
      //     this.$Message.warning("请选择报名时间");
      //     return;
      //   } else {
      //     regStart = this.regDate[0];
      //     regEnd = this.regDate[1];
      //   }
      // }

      // 详情
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("请完善详情信息");
        return;
      }
      
      // let req = {
      //   ExhibitionId: this.exhibitionInfo.id,
      //   AgentId: this.AgentId,
      //   JoinId: this.company.joinId,
      //   Name: this.formInline.name,
      //   Banner: imgList,
      //   Video: video,
      //   RegCountMax: this.formInline.num,
      //   Address: this.formInline.address,
      //   StartTime: startTime,
      //   EndTime: endTime,
      //   IsReg: this.formInline.apply,
      //   RegStart: regStart,
      //   RegEnd: regEnd,
      //   IsCharge: this.formInline.isCharge,
      //   ChargeAmount: this.formInline.price,
      //   ScribingAmount: this.formInline.linePrice,
      //   ShowIndex: this.formInline.showIndex,
      //   Introduction: Introduction
      // }
      let req = {
        Id: this.actId,
        SetValues: {
          Name: this.formInline.name,
          Banner: imgList,
          Video: video,
          // RegCountMax: this.formInline.num,
          Address: this.formInline.address,
          StartTime: startTime,
          EndTime: endTime,
          Timetable: this.formInline.Timetable,
          // IsReg: this.formInline.apply,
          // RegStart: regStart,
          // RegEnd: regEnd,
          // IsCharge: this.formInline.isCharge,
          // ChargeAmount: this.formInline.price,
          // ScribingAmount: this.formInline.linePrice,
          ShowIndex: this.formInline.showIndex,
          Introduction: Introduction
        }
      } 
      let bool = await this.editActInfo(req);
      if (bool.successed) {
        this.$router.push("/host/index/ex/act?id=" + this.editId);
        this.$Message.success("修改成功");
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
      
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList; 
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 15;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleViewVideo(item) {
      this.videoData = item;
      this.visibleVideo = true;
    },
    handleRemoveByArrVideo(file) {
      const fileList = this.uploadListVideo;
      this.uploadListVideo.splice(fileList.indexOf(file), 1);
    },
    handleSuccessVideo(res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadListVideo = this.$refs.uploadVideo.fileList;
        this.coverImg = this.uploadListVideo[0].url +
          `?x-oss-process=video/snapshot,t_${2000},f_jpg,w_590,h_332,m_fast`;
      }
    },
    handleFormatErrorVideo(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传mp4格式的视频`);
      this.uploading = false;
    },
    handleUploadErrorVideo(file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
      this.uploading = false;
    },
    handleMaxSizeVideo(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于50M以下mp4格式的视频`);
    },
    handleBeforeUploadVideo() {
      this.uploading = true;
      const limitNum = 1;
      const check = this.uploadListVideo.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次只能上传${limitNum}条视频`);
      }
      return check;
    },
    handleUploadingVideo(event) {},
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    time1(e) {
      this.applyDate = e;
    },
    time2(e) {
      this.regDate = e;
    },
    changeApply() {
      if (this.formInline.apply === false) {
        this.regDate = [];
        this.formInline.isCharge = false;
      }
      if (this.formInline.isCharge === false) {
        this.formInline.price = 0;
        this.formInline.linePrice = 0;
      }
    },
    changeIsCharge() {
      if (this.formInline.isCharge === false) {
        this.formInline.price = 0;
        this.formInline.linePrice = 0;
      }
    },
    changModal($event) {
      this.Introduction = $event; 
    },
  },
  components: {
    customComponentCommon,
    videoPlayer
  }
};
</script>

<style scoped lang="scss">
.activity-add {
  &-content {
    background-color: #fff;
    padding: 40px 70px 100px 70px;
    margin: 30px;
  }
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  .video-player {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
}
</style>
<style lang="scss">
  .act-video {
    .ivu-modal-close {
      display: none;
    }
    .ivu-modal-body {
      padding: 0;
    }
  }
</style>